import { SwitchProps as MuiSwitchProps } from '@mui/material';
import { clsx } from 'clsx';
import { Switch } from './Switch';
import {
  InputControlLabelProps,
  InputControlWithLabel
} from '../input-control-with-label/InputControlWithLabel';

export interface SwitchWrapperProps extends Omit<InputControlLabelProps, 'control'> {
  switchProps?: MuiSwitchProps;
}

export function SwitchWrapper(props: SwitchWrapperProps) {
  const { dataId, disabled, switchProps, ...inputControlLabelProps } = props;

  return (
    <InputControlWithLabel
      dataId={dataId}
      disabled={disabled}
      {...inputControlLabelProps}
      control={
        <Switch
          className={clsx('mt-1', switchProps?.className)}
          id={dataId}
          dataId={dataId}
          {...switchProps}
          disabled={disabled}
        />
      }
    />
  );
}
